<template>
  <div>
    <div class="box">
      <div class="topictitle">{{ questionObject.name }}</div>
      <div class="topic__type-des">{{ questionObject.description }}</div>

      <fieldset class="messagevote">
        <div class="form" v-for="(item, index) in titleData" :key="index">
          <div>
            <div></div>
            <div id="divTitle1">
              <span>{{ index + 1 }}.</span>
              {{ item.name }}
              <span v-if="item.type=='1'">(单选)</span>
              <span v-else-if="item.type=='2'">(多选)</span>
              <span v-else>(问答)</span>
            </div>
          </div>

          <!-- 单选 -->
          <div v-if="item.type == '1' ? true : false">
            <!-- type为1是单选，2是多选 -->
            <ul class="ulradiocheck">
              <li style="width: 99%" v-for="items in item.choiceList" :key="items.id">
                <input
                  type="radio"
                  :name="item.id"
                  :id="items.id"
                  :value="items.name"
                  :checked="items.checked"
                  style="margin-right:10px"
                />
                <label :for="items.id">{{items.name }}</label>
                <div v-if="items.isIdea" class="disinput">
                  <div class="addRedEnd" v-if="items.isMust"></div>
                  <el-input
                    class="disinputText"
                    v-model="items.idea"
                    type="text"
                    placeholder="请填写意见"
                  ></el-input>
                </div>
              </li>
            </ul>
          </div>

          <!-- 多选 -->
          <div v-if="item.type == '2' ? true : false">
            <ul>
              <li
                style="width: 99%;margin-left: 20px;margin-top:8px"
                v-for="items in item.choiceList"
                :key="items.id"
              >
                <input
                  type="checkbox"
                  :name="item.id"
                  :id="items.id"
                  :value="items.name"
                  :label="items.checked"
                  :checked="items.checked"
                  style="margin-right:10px"
                />
                <label :for="items.id">{{ items.name}}</label>
                <div v-if="items.isIdea" class="disinput">
                  <div class="addRedEnd" v-if="items.isMust"></div>
                  <el-input
                    class="disinputText"
                    v-model="items.idea"
                    type="text"
                    placeholder="请填写意见"
                  ></el-input>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="item.type=='3'? true : false">
            <textarea
              class="texta"
              v-model="item.answer"
              placeholder="请输入答案"
              id
              cols="90"
              rows="10"
            ></textarea>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>
import * as vote from '@/api/vote/vote.js';
export default {
  props: ['topicId'],
  data() {
    return {
      questionObject: [], //主题的信息
      titleData: [], //题目的信息
      htmltitle: '',
    };
  },
  created() {
    this.questionsingle();
  },
  methods: {
    //获取当前问卷主题的信息
    questionsingle() {
      let id = { id: this.topicId };
      vote.getPollTopicModel(id).then((res) => {
        this.questionObject = res.result;
        this.htmltitle = res.result.name;
        this.getTitle(res.result.id);
      });
    },

    // 获取题目信息
    getTitle(id) {
      let data = { topicId: this.topicId, userId: this.$store.state.User.ids };
      vote.PollDataGetPollRecord(data).then((res) => {
        this.titleData = res.result;
      });
    },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  margin: 0 auto;
  min-height: 600px;

  background-color: #ffffff;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-radius: 5px;
  border: 1px solid rgba(242, 242, 242, 1);
}
.topictitle {
  font: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Microsoft YaHei',
    'Microsoft YaHei UI', '微软雅黑', sans-serif;
  padding-top: 26px;
  padding: 26px 10px 15px;
  color: #1ea0fa;
  text-align: center;
  font-size: 22px;
}
.title {
  font-size: 20px;
  line-height: 32px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  text-align: center;
}
.topic__type-des {
  font-size: 16px;
  margin: 0 20px;
  padding: 10px 0 20px 0;
  border-bottom: 1px solid #f7f7f7;
}
.texta {
  margin-top: 15px;
  border: 1px solid #f2f2f2;
  padding: 5px 8px;
  font-size: 14px;
}

.req {
  color: red;
  font-weight: bold;
  position: absolute;
  top: 3px;
  left: -10px;
}
fieldset {
  margin: 0 20px;
}
#divTitle1 {
  font-size: 16px;
  margin-top: 10px;
}
.ulradiocheck {
  padding-top: 10px;
  padding-left: 20px;
}
.ulradiocheck li {
  font-size: 14px;
  margin-top: 8px;
}
.addRedEnd:after {
  content: '*';
  color: red;
  font-size: 18px;
}
.form {
  margin-top: 20px;
}
.disinput {
  display: flex;
}
.disinputText {
  width: 400px;
}
/deep/ .el-input__inner {
  height: 33px;
  line-height: 33px;
  padding: 0 5px;
}
</style>